module.exports = __webpack_public_path__ + "static/media/cricle-location-grey.d37b5830.svg";